import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '50%',
  },
  tabPaper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
  },
  MuiBox: {
    padding: 0,
  },
  row: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3.5),
  },
  title: {
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  desc: {
    width: 'calc(100% - 145px)',
    borderBottom: '1px solid #E0E0E0',
    padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  gridPaper: {
    height: '100%',
  },
  tabsPanel: {
    width: '60%',
  },
  textBox: {
    marginTop: theme.spacing(3),
    fontSize: 12,
    maxWidth: 580,
    color: 'rgb(0 0 0 / 54%)',
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(3),
  },
  btn: {
    padding: theme.spacing(1, 3.5),
    fontSize: 14,
    textTransform: 'none',
    marginRight: theme.spacing(1),
  },
}));
